import React from 'react';

import ConstTooltip from '../../../common/mixTable/tooltip/Const';
import TimeZoneHandle from '../../../common/timezone-handle';

const listColumn = [
  {
    key: 'createDate',
    textAlign: 'left',
    format: el => <TimeZoneHandle time={el} />,
    width: '70px',
    isDisSort: true,
  },
  {
    key: 'ticker',
    textAlign: 'left',
    isIconGraph: true,
    width: '70px',
    keyOrgCode: 'ticker',
    isString: true,
  },
  {
    isAlertMessage: true,
    key: 'message',
    textAlign: 'left',
    typeTooltip: ConstTooltip.typeHover.hoverAlertSystem,
    keyOrgCode: 'organCode',
    isDisSort: true,
    isTruncate: true,
    hasNewsId: true,
    width: '100%',
  },
];

const alertGroups = [
  'All',
  'BreakOut',
  'FallDown',
  'FinancialAssessment',
  'Ranking',
  'Technical',
  'CompanyEvents',
  'PriceVolume',
  'PersonalAlert',
];

const mapGroupCodes = {
  All: [''],
  BreakOut: [
    'RevenueBreakoutQuarterly',
    'ProfitBreakoutQuarterly',
    'RevenueBreakoutYear',
    'ProfitBreakoutYear',
  ],
  FallDown: [
    'RevenueFallDownQuarterly',
    'ProfitFallDownQuarterly',
    'RevenueFallDownYear',
    'ProfitFallDownYear',
  ],
  FinancialAssessment: ['WatchoutQuarter', 'WatchoutYear'],
  Ranking: ['UpgradeScoringIndustry', 'UpgradeScoringGroup'],
  Technical: [
    'CEFLAbnormality',
    'Cancelled',
    'Pressing',
    'Agressive',
    'Closing',
    'AccumulationBreak',
    'BreakoutTop',
    'BreakoutBottom',
    'BreakoutShortermMa',
    'BreakLongtermMA',
  ],
  CompanyEvents: [
    'CorporateEarning',
    'StockDividend',
    'CorporateAgm',
    'Economy',
    'PersonTransaction',
    'CorporateTransaction',
    'Corporate_IPO',
    'CorporateListing',
  ],
  PriceVolume: [
    'VolumeIncreasePriceIncrease',
    'PriceIncrease',
    'VolumeIncrease',
    'BreakoutVolume',
    'VolumeIncreasePriceDecrease',
    'PriceDecrease',
  ],
  PersonalAlert: [
    'Notification.CROSSMA',
    'Notification.PRICEINCREASE',
    'Notification.VOLUMEINCREASE',
    'Notification.BREAKBOTTOM',
    'Notification.BREAKTOP',
    'Notification.PRICEDESCREASE',
  ],
};

const alertGroupDropDownData = {
  All: { key: 'All', name: 'alerts.alertCode.All' },
  BreakOut: { key: 'BreakOut', name: 'alerts.alertCode.BreakOut' },
  FallDown: { key: 'FallDown', name: 'alerts.alertCode.FallDown' },
  FinancialAssessment: {
    key: 'FinancialAssessment',
    name: 'alerts.alertCode.FinancialAssessment',
  },
  Ranking: { key: 'Ranking', name: 'alerts.alertCode.Ranking' },
  Technical: { key: 'Technical', name: 'alerts.alertCode.Technical' },
  CompanyEvents: {
    key: 'CompanyEvents',
    name: 'alerts.alertCode.CompanyEvents',
  },
  PriceVolume: { key: 'PriceVolume', name: 'alerts.alertCode.PriceVolume' },
  PersonalAlert: {
    key: 'PersonalAlert',
    name: 'alerts.alertCode.PersonalAlert',
  },
};

export default {
  listColumn,
  maxRowData: 50,
  alertGroupDropDownData,
  alertGroups,
  mapGroupCodes,
};
